<template>
    <div class="bind-phone-success">
        <div class="bind-phone-tip-new bind-phone-tip-success">
            <veui-icon class="bind-phone-tip-icon" name="check-circle-solid"/>
            <div class="bind-phone-tip-text">您已完成呼叫绑定,该绑定关系可持续30min,30min之后将不能再拨出用户号码,请您尽快与用户联系。</div>
        </div>
        <div class="bind-phone-show">
            <div class="bind-phone-show-content">
                <div class="bind-phone-show-text">绑定呼出号码:</div>
                <div class="bind-phone-show-num">{{ bindInfo.tela }}</div>
            </div>
            <div class="bind-phone-show-center"></div>
            <div class="bind-phone-show-content">
                <div class="bind-phone-show-text">用户虚拟号码:</div>
                <div class="bind-phone-show-num">{{ bindInfo.telx }}</div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file bindPhoneSuccess.vue
 * @desc 线索详情绑定成功
 * @author sunxiaofeng01
 */
import 'veui-theme-dls-icons/check-circle-solid';
import {Icon} from 'veui';

export default {
    name: 'bindPhoneSuccess',
    props: {
        bindInfo: {
            'type': Object,
            'default': () => {}
        }
    },
    components: {
        'veui-icon': Icon
    }
};
</script>

<style scoped lang="stylus">
.bind-phone-success
    margin-bottom 24px
    .bind-phone-tip-new
        display flex
        padding 4px 23px 4px 16px
        background #F0F6FF
        border-radius 4px
        .bind-phone-tip-icon
            font-size 22px
            color #0052CD
            margin -1px 8px 0 0
    .bind-phone-tip-success
        background #F2FFF8
        .bind-phone-tip-icon
            color #00BF5C
    .bind-phone-show-num
        font-family: PingFangSC-Medium;
        font-size: 24px;
        color: #282C33;
        font-weight: 500;
        margin-top 8px
        line-height 24px
    .bind-phone-show
        display flex
        align-items center
        margin 24px 0
        .bind-phone-show-content
            width 150px
            flex-shrink 0
            flex-grow 0
            text-align left
            color #282C33
        .bind-phone-show-text
            font-size 14px
            line-height 14px
        .bind-phone-show-center
            width 64px
            height 24px
            flex 1
            margin 0 10px
            background url('../image/icon-phone.png') center center no-repeat
            background-size 100% 100%
</style>
